import { gql } from 'graphql-request'

export const QueryBlockSectionHeader = gql`
  fragment FragmentBlockSectionHeader on BlockSectionHeaderModelRecord {
    __typename
      id
    icon
    preface
    logo {
      mimeType
      url
      alt
      title
      width
      height
      responsiveImage {
        sizes
        src
        width
        height
        alt
        title
        base64
      }
    }
    title
    headingType
    shortDescription {
    value
    links {
      __typename
      ... on ArticleModelRecord {
        id
        slug
      }
      ... on CustomerModelRecord {
        id
        slug
      }
      ... on PageModelRecord {
        id
        slug
      }
      ... on IntegrationModelRecord { 
      	id
        slug
      }
    }
    inlineBlocks
  }
    primaryAction {
      ...FragmentNavigationItem
    }
    secondaryAction {
      ...FragmentNavigationItem
    }
    contentAlignment
    backgroundColor
    anchor
    image {
      mimeType
      url
      title
      width
      height
      video {
        muxPlaybackId
        title
        width
        height
        blurUpThumb
      }
      responsiveImage {
        srcSet
        sizes
        src
        width
        height
        aspectRatio
        alt
        title
        bgColor
        base64
      }
    }
    video {
      ...QueryVideo
    }
  }
`

export const BlockSectionHeader = {
  __typename: 'BlockSectionHeader',
  fragmentName: 'FragmentBlockSectionHeader',
  fragmentQuery: QueryBlockSectionHeader,
  fragments: ['FragmentNavigationItem', 'QueryVideo']
}
